module.exports = __webpack_public_path__ + "img/62.4d335510.jpg";